import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import Api from '../../component/Api'
import Loading from "../../component/loader/Loading";

const Account = () => {
    
    const [views, setViews] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const userId = sessionStorage.getItem('userId');
    const [dataDo, setDataDo] = useState([])
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");

    useEffect(() => {
        loadDoes();
        fetch(`${Api}/views`)
            .then(res => {
                return res.json();
                // console.log(res.json())
            }).then(resq => {
                setViews(resq.counter)
                // console.log("jj", views)
            }).catch((err) => {
                toast.error('Failed :' + err.message);
            });

    }, [])

    // console.log(views)
    if (views !== null) {
        fetch(`${Api}/views`, {
            method: "PUT",
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ counter: views + 1 })
        }).then((res) => {
            // console.log(views)
        }).catch((err) => {
            toast.error('Failed :' + err.message);
        });
    }


    const loadDoes = () => {
        setIsLoading(true);
        fetch(`${Api}/toDo?userId=${userId}`).then(res => {
            return res.json();
        }).then(res => {
            // console.log(res)
            setDataDo(res)
            setIsLoading(false);
        });
    }


    const handleremove = (id) => {
        if (window.confirm("Do you want to delete this ? ")) {
            setIsLoading(true);
            fetch(`${Api}/toDo/${id}`, {
                method: "Delete",
                headers: { 'content-type': 'application/json' },

            }).then((res) => {
                toast.success('Deleted successfully.')
                setTimeout(() => loadDoes(), 100)
                setIsLoading(false);
            }).catch((err) => {
                toast.error('Failed :' + err.message);
                setIsLoading(false);
            });

        }

    }


    const IsValidate = () => {
        let isproceed = true;
        let errormessage = 'Please enter the value in ';
        if (title === null || title === '') {
            isproceed = false;
            errormessage += ' Title ';
        }

        if (content === null || content === '') {
            isproceed = false;
            errormessage += ' Content';
        }
        if (!isproceed) {
            toast.warning(errormessage)
        }
        return isproceed;
    }


    const handlesubmit = (e) => {
        e.preventDefault();
        let data = { title, content, userId };
        if (IsValidate()) {
            // console.log(data);
            setIsLoading(true);
            fetch(`${Api}/toDo`, {
                method: "POST",
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(data)
            }).then((res) => {
                toast.success('Added successfully.')
                setTitle("");
                setContent("");
                setTimeout(() => loadDoes(), 100)
                setIsLoading(false);
            }).catch((err) => {
                toast.error('Failed :' + err.message);
                setIsLoading(false);
            });
        }
    }

    return (
        <div className="container  my-5">
            {isLoading ? <Loading /> : " "}
            <h1 className="text-center mb-5">what will you do  </h1>

            <form className="mb-5 text-center" onSubmit={handlesubmit}>
                <div className="mb-3">
                    <label htmlFor="exampleFormControlInput1" className="form-label">Title</label>
                    <input type="text" className="form-control" id="exampleFormControlInput1" placeholder="Enter title" value={title} onChange={e => { setTitle(e.target.value) }} />
                </div>
                <div className="mb-3">
                    <label htmlFor="exampleFormControlTextarea1" className="form-label">Content</label>
                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Enter content" value={content} onChange={e => { setContent(e.target.value) }}></textarea>
                </div>
                <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                    <button type="submit" className="btn btn-primary btn-lg px-4 gap-3">Add New</button>
                </div>
            </form>

            <div className="card rounded ">
                {dataDo &&
                    dataDo.map((item, index) => (

                        <div key={index} className={index % 2 === 0 ? "bg-info card-body mb-4 rounded" : "bg-primary card-body mb-4 rounded"} data-aos="zoom-in">
                            <h5 className="card-title">{item.title}</h5>
                            <p className="card-text"> {item.content}</p>
                            <button onClick={() => handleremove(item.id)} className="btn btn-danger">Remove</button>
                        </div>

                    )
                    )
                }
            </div>

        </div>


    );
}

export default Account;